module.exports = "/_next/static/files/9e335445209fad51092cb528b00f4955.svg";